import { createFileRoute } from "@tanstack/react-router";
import ProcessPage from "../pages/Experiments/ProcessPage";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/experiments/process")({
  component: ExperimentsProcessRoute,
});

function ExperimentsProcessRoute() {
  return (
    <RequireAuth require="experimentsManage">
      <ProcessPage />
    </RequireAuth>
  );
}
